import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { LoginService } from './../services/login.service';

@Component({
    selector: 'app-user-exist-confirmation-dialog',
    templateUrl: './userExistConfirmationDialog.component.html',
})
export class UserExistConfirmationDialogComponent implements OnInit {


    constructor(public dialogRef: MatDialogRef<UserExistConfirmationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string, public vcRef: ViewContainerRef, private route: Router,
        private loginService: LoginService) {
        dialogRef.disableClose = true;
    }

    ngOnInit() { }

    onNoClick(event): void {
        if (event == "LoginPage") {
            this.loginService.IsForgetPassword = false
        } else if (event == "ForgetPassword") {
            this.loginService.IsForgetPassword = true
        }
        this.route.navigate(['/login']);
        this.dialogRef.close(event);
    }
}
